import H6Text from './H6Text';

export default H6Text;
